import { murmur3 } from 'murmurhash-js';
import stringify from 'json-stable-stringify';
var SEED = 2;
export default function hash(obj) {
  // ensure that the value will never be read as a number
  // by adding non-numeric characters to the return
  // because lodash set is convenient, but tricky
  return "x".concat(murmur3(stringify(obj), SEED));
}